<template>
  <div class="box-list-ebid">
    <Navbar />
    <div class="list-ebid">
      <b-container class="text-left">
        <b-row>
          <b-col lg="6" class="ads-block" v-if="customer">
            <a href="https://lin.ee/qycPONr" target="_BLANK">
              <b-img
                class="img-ads"
                center
                src="https://www.kmppartners.info/ebidding/img/BannerAds1.jpg"
                alt="Ads"
              ></b-img>
            </a>
          </b-col>
          <b-col lg="6" class="ads-block" v-if="customer">
            <a href="https://lin.ee/qycPONr" target="_BLANK">
              <b-img
                class="img-ads"
                center
                src="https://www.kmppartners.info/ebidding/img/BannerAds2.jpg"
                alt="Ads"
              ></b-img>
            </a>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="10" class="table">
            <vue-good-table
              ref="table-data"
              :search-options="{ enabled: true }"
              :columns="columns"
              :rows="rows"
              :pagination-options="{
                enabled: true,
                mode: 'records',
                perPage: 10,
                position: 'bottom',
                perPageDropdown: [10, 25, 50],
                dropdownAllowAll: false,
                setCurrentPage: 1,
                nextLabel: 'ถัดไป',
                prevLabel: 'ก่อนหน้า',
                rowsPerPageLabel: 'จำนวนข้อมูลต่อหน้า',
                ofLabel: 'จาก',
              }"
              @on-row-click="selectEbidding"
            >
              <template slot="table-row" slot-scope="props" v-if="!customer">
                <span v-if="props.column.field == 'announce_date'">
                  <span
                    v-if="props.row.approved === '1'"
                    style="font-weight: bold; color: green"
                    >{{ props.row.announce_date }}</span
                  >
                </span>
                <span v-if="props.column.field == 'announce_date'">
                  <span
                    v-if="props.row.approved === '0'"
                    style="font-weight: bold"
                    >{{ props.row.announce_date }}</span
                  >
                </span>
                <span v-if="props.column.field == 'project_no'">
                  <span
                    v-if="props.row.approved === '1'"
                    style="font-weight: bold; color: green"
                    >{{ props.row.project_no }}</span
                  >
                </span>
                <span v-if="props.column.field == 'project_no'">
                  <span
                    v-if="props.row.approved === '0'"
                    style="font-weight: bold"
                    >{{ props.row.project_no }}</span
                  >
                </span>
                <span v-if="props.column.field == 'auction_price'">
                  <span
                    v-if="props.row.approved === '1'"
                    style="font-weight: bold; color: green"
                    >{{ formatFn(props.row.auction_price) }}</span
                  >
                </span>
                <span v-if="props.column.field == 'auction_price'">
                  <span
                    v-if="props.row.approved === '0'"
                    style="font-weight: bold"
                    >{{ formatFn(props.row.auction_price) }}</span
                  >
                </span>
                <span v-if="props.column.field == 'company_name'">
                  <span
                    v-if="props.row.approved === '1'"
                    style="font-weight: bold; color: green"
                    >{{ props.row.company_name }}</span
                  >
                </span>
                <span v-if="props.column.field == 'company_name'">
                  <span
                    v-if="props.row.approved === '0'"
                    style="font-weight: bold"
                    >{{ props.row.company_name }}</span
                  >
                </span>
                <span v-if="props.column.field == 'discount'">
                  <span
                    v-if="props.row.approved === '1'"
                    style="font-weight: bold; color: green"
                    >{{ props.row.discount }}</span
                  >
                </span>
                <span v-if="props.column.field == 'discount'">
                  <span
                    v-if="props.row.approved === '0'"
                    style="font-weight: bold"
                    >{{ props.row.discount }}</span
                  >
                </span>
                <span v-if="props.column.field == 'project_name'">
                  <span
                    v-if="props.row.approved === '1'"
                    style="font-weight: bold; color: green"
                    >{{ props.row.project_name }}</span
                  >
                </span>
                <span v-if="props.column.field == 'project_name'">
                  <span
                    v-if="props.row.approved === '0'"
                    style="font-weight: bold"
                    >{{ props.row.project_name }}</span
                  >
                </span>
                <span v-if="props.column.field == 'province_name'">
                  <span
                    v-if="props.row.approved === '1'"
                    style="font-weight: bold; color: green"
                    >{{ props.row.province_name }}</span
                  >
                </span>
                <span v-if="props.column.field == 'province_name'">
                  <span
                    v-if="props.row.approved === '0'"
                    style="font-weight: bold"
                    >{{ props.row.province_name }}</span
                  >
                </span>
                <span v-if="props.column.field == 'standard_price'">
                  <span
                    v-if="props.row.approved === '1'"
                    style="font-weight: bold; color: green"
                    >{{ formatFn(props.row.standard_price) }}</span
                  >
                </span>
                <span v-if="props.column.field == 'standard_price'">
                  <span
                    v-if="props.row.approved === '0'"
                    style="font-weight: bold"
                    >{{ formatFn(props.row.standard_price) }}</span
                  >
                </span>
              </template>
              <div slot="table-actions">
                <b-button
                  v-if="!customer"
                  @click="addEbid"
                  size="sm"
                  style="margin-right: 10px; background-color: #005a7c"
                >
                  <font-awesome-icon icon="plus" />&nbsp;เพิ่มประกาศ
                </b-button>
                <b-button
                  target="_blank"
                  href="http://www.gprocurement.go.th/new_index.html"
                  size="sm"
                  style="margin-right: 10px; background-color: #005a7c"
                >
                  <font-awesome-icon icon="search" />&nbsp;จัดซื้อจัดจ้างภาครัฐ
                </b-button>
              </div>
            </vue-good-table>
          </b-col>
          <b-col class="search" lg="2">
            <b-row>
              <b-col>
                <b-row class="head-search">
                  <b-col lg="12">
                    <h4>ค้นหาประกาศ</h4>
                  </b-col>
                </b-row>
                <b-row class="content-search">
                  <b-col lg="12" md="6" class="mb-2">
                    วันที่:
                    <div class="input-group">
                      <b-form-datepicker
                        size="sm"
                        v-model="current_date_start"
                        locale="th"
                      ></b-form-datepicker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <b-button
                            class="btnsearch"
                            style="width: 100%"
                            size="sm"
                            @click="current_date_start = null"
                          >
                            <font-awesome-icon icon="redo-alt" />
                          </b-button>
                        </span>
                      </div>
                    </div>
                  </b-col>
                  <b-col lg="12" md="6" class="mb-2">
                    ถึง:
                    <div class="input-group">
                      <b-form-datepicker
                        size="sm"
                        v-model="current_date_end"
                        locale="th"
                      ></b-form-datepicker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <b-button
                            class="btnsearch"
                            style="width: 100%"
                            size="sm"
                            @click="current_date_end = null"
                          >
                            <font-awesome-icon icon="redo-alt" />
                          </b-button>
                        </span>
                      </div>
                    </div>
                  </b-col>
                  <b-col lg="12" class="space mt-1 mb-2">
                    <b-button
                      class="btnsearch"
                      style="width: 100%"
                      size="sm"
                      @click="search"
                    >
                      <font-awesome-icon icon="search" />
                    </b-button>
                  </b-col>
                  <b-col lg="12" md="4">
                    <span v-if="customer">ผู้ชนะการประมูล:</span>
                    <span v-if="!customer">ผู้รับเหมา:</span>
                    <div class="input-group mb-3">
                      <b-form-input
                        list="list-company"
                        size="sm"
                        v-model="company_name"
                      ></b-form-input>
                      <datalist id="list-company">
                        <option
                          v-bind:key="company_name"
                          v-for="company_name in options_company"
                        >
                          {{ company_name }}
                        </option>
                      </datalist>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <b-button class="btnsearch" size="sm" @click="search">
                            <font-awesome-icon icon="search" />
                          </b-button>
                          <b-button
                            class="btnsearch"
                            style="width: 100%"
                            size="sm"
                            @click="company_name = null"
                          >
                            <font-awesome-icon icon="redo-alt" />
                          </b-button>
                        </span>
                      </div>
                    </div>
                  </b-col>
                  <b-col lg="12" md="4">
                    รหัสโครงการ:
                    <div class="input-group mb-3">
                      <b-form-input
                        size="sm"
                        v-model="project_no"
                      ></b-form-input>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <b-button class="btnsearch" size="sm" @click="search">
                            <font-awesome-icon icon="search" />
                          </b-button>
                          <b-button
                            class="btnsearch"
                            style="width: 100%"
                            size="sm"
                            @click="project_no = null"
                          >
                            <font-awesome-icon icon="redo-alt" />
                          </b-button>
                        </span>
                      </div>
                    </div>
                  </b-col>
                  <b-col lg="12" md="4">
                    จังหวัด:
                    <div class="input-group mb-3">
                      <b-form-input
                        list="list-province"
                        size="sm"
                        v-model="province_name"
                      ></b-form-input>
                      <datalist id="list-province">
                        <option
                          v-bind:key="province_name"
                          v-for="province_name in options_province"
                        >
                          {{ province_name }}
                        </option>
                      </datalist>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <b-button class="btnsearch" size="sm" @click="search">
                            <font-awesome-icon icon="search" />
                          </b-button>
                          <b-button
                            class="btnsearch"
                            style="width: 100%"
                            size="sm"
                            @click="province_name = null"
                          >
                            <font-awesome-icon icon="redo-alt" />
                          </b-button>
                        </span>
                      </div>
                    </div>
                  </b-col>
                  <b-col lg="12" md="4" v-if="!customer">
                    ประเภทงาน:
                    <div class="input-group mb-3">
                      <b-form-select
                        list="list-province-select"
                        size="sm"
                        v-model="job_type"
                        required
                        :options="options_job_type"
                      ></b-form-select>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <b-button class="btnsearch" size="sm" @click="search">
                            <font-awesome-icon icon="search" />
                          </b-button>
                          <b-button
                            class="btnsearch"
                            style="width: 100%"
                            size="sm"
                            @click="job_type = null"
                          >
                            <font-awesome-icon icon="redo-alt" />
                          </b-button>
                        </span>
                      </div>
                    </div>
                  </b-col>
                  <b-col lg="12" md="4">
                    <span>หน่วยงาน:</span>
                    <div class="input-group mb-3">
                      <b-form-input
                        list="list-employer"
                        size="sm"
                        v-model="employer"
                      ></b-form-input>
                      <datalist id="list-employer">
                        <option
                          v-bind:key="employer"
                          v-for="employer in options_employer"
                        >
                          {{ employer }}
                        </option>
                      </datalist>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <b-button class="btnsearch" size="sm" @click="search">
                            <font-awesome-icon icon="search" />
                          </b-button>
                          <b-button
                            class="btnsearch"
                            style="width: 100%"
                            size="sm"
                            @click="employer = null"
                          >
                            <font-awesome-icon icon="redo-alt" />
                          </b-button>
                        </span>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row class="mt-3" v-if="customer">
              <b-col class="ads-block">
                <a href="https://lin.ee/qycPONr" target="_BLANK">
                  <b-img
                    class="img-ads"
                    center
                    src="https://www.kmppartners.info/ebidding/img/LeftBoxAds1.jpg"
                    alt="Ads"
                  ></b-img>
                </a>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <b-modal
      ref="modal-ebid"
      size="lg"
      title="ประกาศผู้ชนะการประกวดราคา"
      hide-footer
      centered
    >
      <b-form @submit="updateEbid">
        <b-container fluid>
          <b-row>
            <b-col lg="12">
              <b-row class="mb-3">
                <b-col>
                  <b-row>
                    <b-col lg="4">
                      วันที่ประกาศ
                      <span class="label" v-if="!approved">*</span>
                    </b-col>
                    <b-col>
                      <b-form-input
                        required
                        :disabled="approved"
                        ref="date-input"
                        v-model="data_selected.announce_date"
                        size="sm"
                      ></b-form-input>
                      <small>วว-ดด-ปปปป</small>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col>
                  <b-row>
                    <b-col lg="4">
                      รหัสโครงการ
                      <span class="label" v-if="!approved">*</span>
                    </b-col>
                    <b-col>
                      <b-form-input
                        required
                        size="sm"
                        :disabled="approved"
                        v-model="data_selected.project_no"
                      ></b-form-input>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row class="mb-4">
                <b-col>
                  <b-row>
                    <b-col>
                      <b-row class="mb-2">
                        <b-col lg="4">
                          บริษัท
                          <span class="label" v-if="!approved">*</span>
                        </b-col>
                        <b-col>
                          <span>
                            <b-form-input
                              list="list-company-select"
                              size="sm"
                              v-model="select_company"
                              :disabled="approved"
                              required
                            ></b-form-input>
                            <datalist id="list-company-select">
                              <option
                                v-bind:key="select_company"
                                :disabled="approved"
                                v-for="select_company in options_company"
                              >
                                {{ select_company }}
                              </option>
                            </datalist>
                          </span>
                        </b-col>
                      </b-row>
                      <b-row class="mb-2">
                        <b-col lg="4">
                          ราคากลาง
                          <span class="label" v-if="!approved">*</span>
                        </b-col>
                        <b-col>
                          <b-form-input
                            required
                            size="sm"
                            @change="calDiscount"
                            :disabled="approved"
                            v-model="data_selected.standard_price"
                          ></b-form-input>
                        </b-col>
                      </b-row>
                      <b-row class="mb-2">
                        <b-col lg="4">
                          ราคาประมูล
                          <span class="label" v-if="!approved">*</span>
                        </b-col>
                        <b-col>
                          <b-form-input
                            required
                            size="sm"
                            :disabled="approved"
                            @change="calDiscount"
                            v-model="data_selected.auction_price"
                          ></b-form-input>
                        </b-col>
                      </b-row>
                      <!-- <b-row class="mb-2">
                        <b-col lg="4">
                          ส่วนลด (%)
                        </b-col>
                        <b-col>
                          <b-form-input
                            size="sm"
                            disabled
                            v-model="data_selected.discount"
                          ></b-form-input>
                        </b-col>
                      </b-row>-->
                      <b-row class="mb-2">
                        <b-col lg="4">
                          หน่วยงาน
                          <span class="label" v-if="!approved">*</span>
                        </b-col>
                        <b-col>
                          <b-form-textarea
                            required
                            size="sm"
                            :disabled="approved"
                            v-model="data_selected.employor"
                          ></b-form-textarea>
                        </b-col>
                      </b-row>
                      <b-row class="mb-2">
                        <b-col lg="4">
                          จังหวัด
                          <span class="label" v-if="!approved">*</span>
                        </b-col>
                        <b-col>
                          <b-form-input
                            list="list-province-select"
                            size="sm"
                            v-model="select_province"
                            :disabled="approved"
                            required
                          ></b-form-input>
                          <datalist id="list-province-select">
                            <option
                              v-bind:key="select_province"
                              v-for="select_province in options_province"
                            >
                              {{ select_province }}
                            </option>
                          </datalist>
                        </b-col>
                      </b-row>
                      <b-row class="mb-2">
                        <b-col lg="4">
                          ประเภทงาน
                          <span class="label" v-if="!approved">*</span>
                        </b-col>
                        <b-col>
                          <b-form-select
                            list="list-province-select"
                            size="sm"
                            v-model="data_selected.job_type"
                            :disabled="approved"
                            required
                            :options="options_job_type"
                          ></b-form-select>
                        </b-col>
                      </b-row>
                      <b-row class="mb-2">
                        <b-col lg="4">วันเชิญชวน</b-col>
                        <b-col>
                          <b-form-input
                            ref="date-input-invit"
                            size="sm"
                            v-model="data_selected.date_invite"
                            :disabled="approved"
                          ></b-form-input>
                          <small>วว-ดด-ปปปป</small>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col>
                  <b-row class="mb-2">
                    <b-col lg="4">
                      ชื่อโครงการ
                      <span class="label" v-if="!approved">*</span>
                    </b-col>
                    <b-col>
                      <b-form-textarea
                        required
                        size="sm"
                        v-model="data_selected.project_name"
                        rows="9"
                        :disabled="approved"
                      ></b-form-textarea>
                    </b-col>
                  </b-row>
                  <b-row v-if="data_selected.document !== null">
                    <b-col lg="4">ไฟล์เอกสาร</b-col>
                    <b-col :class="edit ? 'text-right' : 'text-left'">
                      <b-link
                        v-if="!approved && !edit"
                        target="_BLANK"
                        :href="data_selected.document"
                        ><u>{{ data_selected.project_no }}.pdf</u></b-link
                      >
                      <b-form-file
                        class="mb-1 text-left"
                        v-else
                        v-model="file_edit"
                        placeholder="คลิกเพื่อเลือก"
                        @input="getBase64()"
                        browse-text="ไฟล์"
                        accept=".pdf"
                      ></b-form-file>
                      <b-button
                        v-if="!approved && !edit"
                        class="ml-2"
                        size="sm"
                        @click="editDocument()"
                        variant="primary"
                        ><font-awesome-icon icon="edit"
                      /></b-button>
                      <b-button
                        v-if="!approved && edit"
                        size="sm"
                        variant="danger"
                        @click="closeEditDocument()"
                        ><font-awesome-icon icon="times"
                      /></b-button>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row class="mb-3">
                <b-col>
                  <b-button
                    v-if="ctlLock && !approved"
                    class="ml-2 float-right"
                    @click="lock"
                    variant="success"
                    size="sm"
                    >ล็อค</b-button
                  >
                  <b-button
                    v-if="ctlLock && approved"
                    class="ml-2 float-right"
                    variant="success"
                    @click="unlock"
                    size="sm"
                    >ปลดล็อค</b-button
                  >
                  <b-button
                    type="submit"
                    class="ml-2 float-right"
                    size="sm"
                    variant="warning"
                    v-if="!approved"
                    >เเก้ไขข้อมูล</b-button
                  >
                  <b-button
                    class="ml-2 float-right"
                    @click="closeEbid"
                    variant="danger"
                    size="sm"
                    >ปิดหน้าต่าง</b-button
                  >
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
      </b-form>
    </b-modal>
    <b-modal
      ref="modal-ebid-cust"
      size="lg"
      title="ประกาศผู้ชนะการประกวดราคา"
      hide-footer
      centered
    >
      <b-form @submit="updateEbid">
        <b-container fluid>
          <b-row>
            <b-col lg="12">
              <b-row class="mb-3">
                <b-col>
                  <b-row>
                    <b-col lg="4">วันที่ประกาศ</b-col>
                    <b-col>
                      <b-form-input
                        required
                        disabled
                        v-model="data_selected.announce_date"
                        size="sm"
                      ></b-form-input>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col>
                  <b-row>
                    <b-col lg="4">รหัสโครงการ</b-col>
                    <b-col>
                      <b-form-input
                        required
                        disabled
                        size="sm"
                        v-model="data_selected.project_no"
                      ></b-form-input>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row class="mb-4">
                <b-col>
                  <b-row>
                    <b-col>
                      <b-row class="mb-2">
                        <b-col lg="4">บริษัท/ห้างหุ้นส่วน</b-col>
                        <b-col>
                          <div class="input-group mb-3" v-if="customer">
                            <b-form-textarea
                              list="list-company-select"
                              size="sm"
                              v-model="select_company"
                              disabled
                            ></b-form-textarea>
                            <div class="input-group-append">
                              <span class="input-group-text">
                                <b-button
                                  class="btnsearch coms"
                                  size="sm"
                                  @click="searchCom"
                                >
                                  <font-awesome-icon icon="search" />
                                </b-button>
                              </span>
                            </div>
                          </div>
                          <span v-if="!customer">
                            <b-form-input
                              list="list-company-select"
                              size="sm"
                              v-model="select_company"
                              :disabled="customer"
                            ></b-form-input>
                            <datalist id="list-company-select">
                              <option
                                v-bind:key="select_company"
                                v-for="select_company in options_company"
                              >
                                {{ select_company }}
                              </option>
                            </datalist>
                          </span>
                        </b-col>
                      </b-row>
                      <b-row class="mb-2">
                        <b-col lg="4">ราคากลาง</b-col>
                        <b-col>
                          <b-form-input
                            required
                            size="sm"
                            disabled
                            @change="calDiscount"
                            v-model="data_selected.standard_price"
                          ></b-form-input>
                        </b-col>
                      </b-row>
                      <b-row class="mb-2">
                        <b-col lg="4">ราคาประมูล</b-col>
                        <b-col>
                          <b-form-input
                            required
                            size="sm"
                            @change="calDiscount"
                            disabled
                            v-model="data_selected.auction_price"
                          ></b-form-input>
                        </b-col>
                      </b-row>
                      <!-- <b-row class="mb-2">
                        <b-col lg="4">
                          ส่วนลด (%)
                        </b-col>
                        <b-col>
                          <b-form-input
                            required
                            size="sm"
                            disabled
                            v-model="data_selected.discount"
                          ></b-form-input>
                        </b-col>
                      </b-row>-->
                      <b-row class="mb-2">
                        <b-col lg="4">หน่วยงาน</b-col>
                        <b-col>
                          <b-form-textarea
                            required
                            size="sm"
                            disabled
                            v-model="data_selected.employor"
                          ></b-form-textarea>
                        </b-col>
                      </b-row>
                      <b-row class="mb-2">
                        <b-col lg="4">จังหวัด</b-col>
                        <b-col>
                          <b-form-input
                            list="list-province-select"
                            size="sm"
                            v-model="select_province"
                            disabled
                          ></b-form-input>
                          <datalist id="list-province-select">
                            <option
                              v-bind:key="select_province"
                              v-for="select_province in options_province"
                            >
                              {{ select_province }}
                            </option>
                          </datalist>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col>
                  <b-row class="mb-2">
                    <b-col lg="4">ชื่อโครงการ</b-col>
                    <b-col>
                      <b-form-textarea
                        disabled
                        required
                        size="sm"
                        v-model="data_selected.project_name"
                        rows="9"
                      ></b-form-textarea>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="4">ไฟล์เอกสาร</b-col>
                    <b-col>
                      <b-link target="_BLANK" :href="data_selected.document"
                        ><u>{{ data_selected.project_no }}.pdf</u></b-link
                      >
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row class="mt-2 text-right">
                <b-col class="content-text">
                  <b-button
                    @click="request"
                    size="sm"
                    style="margin-left: 5px"
                    variant="danger"
                  >
                    <font-awesome-icon icon="exclamation-triangle" />&nbsp;
                    แจ้งผิด
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
      </b-form>
    </b-modal>
    <b-modal
      ref="modal-com"
      title="ข้อมูลบริษัท"
      hide-footer
      centered
      scrollable
    >
      <b-container class="text-left">
        <b-row>
          <b-col lg="12">
            <b>
              <font-awesome-icon icon="address-book" />&nbsp;
              <u>ข้อมูลทั่วไป</u>
            </b>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col lg="5" md="5" class="content-text">
            <b>ผู้ชนะการเสนอราคา</b>
          </b-col>
          <b-col lg="7" md="7" class="content-text">
            <b-form-textarea
              disabled
              v-model="customer_show.company_name"
              size="sm"
            ></b-form-textarea>
          </b-col>
        </b-row>
        <b-row v-if="!other">
          <b-col lg="5" md="5" class="content-text">
            <b>วันที่จดทะเบียนจัดตั้ง</b>
          </b-col>
          <b-col lg="7" md="7" class="content-text">
            <b-form-input
              disabled
              v-model="customer_show.date_regist_customer"
              size="sm"
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row v-if="!other">
          <b-col lg="5" md="5" class="content-text">
            <b>ทุนจดทะเบียน</b>
          </b-col>
          <b-col lg="7" md="7" class="content-text">
            <b-form-input
              disabled
              v-model="customer_show.regist_capital_customer"
              size="sm"
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row v-if="!other">
          <b-col lg="5" md="5" class="content-text">
            <b>เลขทะเบียนนิติบุคคล</b>
          </b-col>
          <b-col lg="7" md="7" class="content-text">
            <b-form-input
              disabled
              v-model="customer_show.ebidding_customer_tax"
              size="sm"
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row v-if="!other">
          <b-col lg="5" md="5" class="content-text">
            <b>รายชื่อคณะกรรมการ</b>
          </b-col>
          <b-col lg="7" md="7">
            <b-row>
              <b-col lg="12" class="content-text">
                <b-form-textarea
                  rows="4"
                  disabled
                  v-model="committee"
                  size="sm"
                ></b-form-textarea>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="mt-3" v-if="!other">
          <b-col lg="12">
            <b>
              <font-awesome-icon icon="address-book" />&nbsp;
              <u>ข้อมูลติดต่อ</u>
            </b>
          </b-col>
        </b-row>
        <b-row class="mt-2" v-if="!other">
          <b-col lg="5" md="5" class="content-text">
            <b>ที่ตั้ง</b>
          </b-col>
          <b-col lg="7" md="7" class="content-text">
            <b-form-textarea
              rows="4"
              disabled
              v-model="customer_show.address_customer"
              size="sm"
            ></b-form-textarea>
          </b-col>
        </b-row>
        <b-row class="mt-2" v-if="!other">
          <b-col lg="5" md="5" class="content-text">
            <b>โทรศัพท์</b>
          </b-col>
          <b-col lg="7" md="7" class="content-text">
            <b-form-input
              rows="4"
              disabled
              v-model="customer_show.tel"
              size="sm"
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mt-2" v-if="!other">
          <b-col lg="5" md="5" class="content-text">
            <b>E-mail Address</b>
          </b-col>
          <b-col lg="7" md="7" class="content-text">
            <b-form-input
              rows="4"
              disabled
              v-model="customer_show.email"
              size="sm"
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mt-2 text-right">
          <b-col class="content-text">
            <b-button
              @click="request"
              size="sm"
              style="margin-left: 5px"
              variant="danger"
            >
              <font-awesome-icon icon="exclamation-triangle" />&nbsp; เเจ้งผิด
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
    <b-modal
      ref="content-ads"
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
      data-backdrop="false"
    >
      <b-container class="text-center">
        <b-row class="mb-2">
          <b-col>
            <b>กำลังโหลดข้อมูล กรุณารอสักครู่...</b>
            <b-spinner
              class="ml-3"
              variant="primary"
              label="Spinning"
            ></b-spinner>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col>
            <b-carousel
              href="www.google.com"
              controls
              id="carousel-1"
              v-model="slide"
              :interval="2500"
              background="#ababab"
              img-width="1024"
              img-height="480"
              style="text-shadow: 1px 1px 2px #333"
            >
              <b-carousel-slide
                caption
                text
                img-src="https://www.kmppartners.info/ebidding/img/Slide1.png"
              ></b-carousel-slide>
              <b-carousel-slide
                caption
                text
                img-src="https://www.kmppartners.info/ebidding/img/Slide2.png"
              ></b-carousel-slide>
              <b-carousel-slide
                caption
                text
                img-src="https://www.kmppartners.info/ebidding/img/Slide3.jpg"
              ></b-carousel-slide>
              <b-carousel-slide
                caption
                text
                img-src="https://www.kmppartners.info/ebidding/img/Slide4.jpg"
              ></b-carousel-slide>
            </b-carousel>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
    <Footer />
  </div>
</template>

<script>
import Navbar from "./Navbar";
import Footer from "./Footer";
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import axios from "axios";
export default {
  components: { Navbar, Footer, VueGoodTable },
  data() {
    return {
      other: false,
      ctlLock: false,
      approved: false,
      slide: 0,
      committee: "-",
      customer: true,
      columns: [
        {
          label: "วันที่ประกาศ",
          field: "announce_date",
          width: "9%",
          sortable: false,
        },
        {
          label: "รหัสโครงการ",
          field: "project_no",
          width: "10%",
        },
        {
          label: "ชื่อโครงการ",
          field: "project_name",
        },
        {
          label: "จังหวัด",
          field: "province_name",
          width: "10%",
        },
        {
          label: "บริษัท",
          field: "company_name",
          width: "15%",
        },
        {
          label: "ราคากลาง",
          field: "standard_price",
          type: "number",
          formatFn: this.formatFn,
          width: "10%",
        },
        {
          label: "ราคาประมูล",
          field: "auction_price",
          type: "number",
          formatFn: this.formatFn,
          width: "10%",
        },
        {
          label: "ส่วนลด (%)",
          field: "discount",
          type: "number",
          formatFn: this.formatFn,
          width: "8%",
        },
      ],
      rows: [],
      customer_show: {
        company_name: "-",
        address_customer: "-",
        date_regist_customer: "-",
        regist_capital_customer: "-",
        ebidding_customer_tax: "-",
        tel: "-",
        email: "-",
      },
      edit: false,
      current_date_start: null,
      current_date_end: null,
      province_name: null,
      project_no: null,
      company_name: null,
      options_province: [],
      options_company: [],
      data_selected: {
        document: null,
        date_invite: null,
        project_name: null,
        announce_date: null,
        province_name: null,
        project_no: null,
        company_name: null,
        standard_price: null,
        auction_price: null,
        employor: null,
        updateBy: null,
        id: null,
        discount: null,
        approved_by: null,
        job_type: null,
      },
      file_edit: null,
      job_type: null,
      select_province: null,
      select_company: null,
      access_ipaddress: null,
      ebidding_request_edit_projectno: null,
      ebidding_request_edit_customer_tax: null,
      ebidding_request_edit_remark: null,
      options_job_type: [],
      employer: null,
      options_employer: [],
    };
  },
  mounted() {
    if (this.$session.get("role") !== "Customer") {
      this.customer = false;
    } else {
      this.customer = true;
    }
    axios
      .get("https://www.kmppartners.info:1009/api/ebidding/jobtype")
      .then((res) => {
        this.options_job_type = res.data.response;
      });
    axios.get("http://www.geoplugin.net/json.gp").then((res) => {
      this.access_ipaddress = res.data.geoplugin_request;
    });
    axios
      .get("https://www.kmppartners.info:1009/api/ebidding/employer")
      .then((res) => {
        if (res.data.status) {
          for (let index = 0; index < res.data.response.length; index++) {
            this.options_employer.push(res.data.response[index].employor);
          }
        }
      });
    axios
      .get("https://www.kmppartners.info:1009/api/ebidding/company_name")
      .then((res) => {
        if (res.data.statusCompany) {
          for (let index = 0; index < res.data.response.length; index++) {
            if (this.$session.get("role") === "Customer") {
              if (
                res.data.response[index].ebidding_customer_name !==
                "ปิยะโยธาก่อสร้าง"
              ) {
                this.options_company.push(
                  res.data.response[index].ebidding_customer_name
                );
              }
            } else {
              this.options_company.push(
                res.data.response[index].ebidding_customer_name
              );
            }
          }
        }
      });
    axios
      .get("https://www.kmppartners.info:1009/api/ebidding/province_name")
      .then((res) => {
        if (res.data.statusProvince) {
          for (let index = 0; index < res.data.response.length; index++) {
            this.options_province.push(res.data.response[index].name_th);
          }
        }
      });
  },
  methods: {
    editDocument() {
      this.edit = true;
    },
    closeEditDocument() {
      this.edit = false;
    },
    getBase64() {
      if (this.file_edit.type === "application/pdf") {
        let reader = new FileReader();
        reader.readAsDataURL(this.file_edit);
        reader.onload = () => {
          this.data_selected.document = reader.result;
        };
      } else {
        this.file_edit = null;
        alert("รองรับเฉพาะ PDF เท่านั้น");
      }
    },
    lock: function () {
      this.$bvModal
        .msgBoxConfirm("ยืนยันว่าล็อคข้อมูลไม่ให้เเก้ไขใช่หรือไม่", {
          title: "ต้องการดำเนินการต่อไหม?",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          cancelVariant: "danger",
          headerClass: "p-2 border-bottom-0",
          footerClass: "p-2 border-top-0",
          centered: true,
          okTitle: "ตกลง",
          cancelTitle: "ยกเลิก",
        })
        .then((value) => {
          if (value) {
            axios
              .post("https://www.kmppartners.info:1009/api/ebidding/approved", {
                ebidding_id: this.data_selected.id,
                username: this.$session.get("username"),
              })
              .then((res) => {
                if (res.data.status) {
                  this.$bvModal
                    .msgBoxOk("ดำเนินการเรียบร้อย", {
                      title: "สำเร็จ",
                      size: "sm",
                      buttonSize: "sm",
                      okVariant: "success",
                      headerClass: "p-2 border-bottom-0",
                      footerClass: "p-2 border-top-0",
                      centered: true,
                      okTitle: "ตกลง",
                    })
                    .then((value) => {
                      if (value) {
                        location.reload();
                      }
                    });
                } else {
                  this.$bvModal
                    .msgBoxOk(res.data.error, {
                      title: "ไม่สำเร็จ",
                      size: "sm",
                      buttonSize: "sm",
                      okVariant: "danger",
                      headerClass: "p-2 border-bottom-0",
                      footerClass: "p-2 border-top-0",
                      centered: true,
                      okTitle: "ตกลง",
                    })
                    .then((value) => {
                      if (value) {
                        location.reload();
                      }
                    });
                }
              });
          }
        });
    },
    unlock: function () {
      this.$bvModal
        .msgBoxConfirm("ยืนยันว่าปลดล็อคข้อมูลให้เเก้ไขใช่หรือไม่", {
          title: "ต้องการดำเนินการต่อไหม?",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          cancelVariant: "danger",
          headerClass: "p-2 border-bottom-0",
          footerClass: "p-2 border-top-0",
          centered: true,
          okTitle: "ตกลง",
          cancelTitle: "ยกเลิก",
        })
        .then((value) => {
          if (value) {
            axios
              .post(
                "https://www.kmppartners.info:1009/api/ebidding/cancle_approved",
                {
                  ebidding_id: this.data_selected.id,
                  username: this.$session.get("username"),
                  approved_by: this.data_selected.approved_by,
                }
              )
              .then((res) => {
                if (res.data.status) {
                  this.$bvModal
                    .msgBoxOk("ดำเนินการเรียบร้อย", {
                      title: "สำเร็จ",
                      size: "sm",
                      buttonSize: "sm",
                      okVariant: "success",
                      headerClass: "p-2 border-bottom-0",
                      footerClass: "p-2 border-top-0",
                      centered: true,
                      okTitle: "ตกลง",
                    })
                    .then((value) => {
                      if (value) {
                        location.reload();
                      }
                    });
                } else {
                  this.$bvModal
                    .msgBoxOk(res.data.error, {
                      title: "ไม่สำเร็จ",
                      size: "sm",
                      buttonSize: "sm",
                      okVariant: "danger",
                      headerClass: "p-2 border-bottom-0",
                      footerClass: "p-2 border-top-0",
                      centered: true,
                      okTitle: "ตกลง",
                    })
                    .then((value) => {
                      if (value) {
                        location.reload();
                      }
                    });
                }
              });
          }
        });
    },
    hideAds: function () {
      this.$refs["content-ads"].hide();
      this.$refs["modal-ebid-cust"].show();
    },
    hideAdsSearch: function () {
      this.$refs["content-ads"].hide();
    },
    request: function () {
      this.$bvModal
        .msgBoxConfirm("ต้องเเจ้งข้อมูลไม่ถูกต้องหรือไม่", {
          title: "ต้องการดำเนินการต่อไหม?",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          cancelVariant: "danger",
          headerClass: "p-2 border-bottom-0",
          footerClass: "p-2 border-top-0",
          centered: true,
          okTitle: "ตกลง",
          cancelTitle: "ยกเลิก",
        })
        .then((value) => {
          if (value) {
            axios
              .post(
                "https://www.kmppartners.info:1009/api/ebidding/add/request",
                {
                  ebidding_request_edit_projectno: this
                    .ebidding_request_edit_projectno,
                  ebidding_request_edit_customer_tax: this
                    .ebidding_request_edit_customer_tax,
                  ebidding_request_edit_remark: this
                    .ebidding_request_edit_remark,
                  request_by: this.$session.get("username"),
                }
              )
              .then((res) => {
                if (res.data.status) {
                  axios.post(
                    "https://www.kmppartners.info:1009/api/notify/both",
                    {
                      bearerSlack:
                        "xoxb-969680262326-1086010624482-XBrFyzCSqF2JFvaAeVfQfahv",
                      msg:
                        "มีการเเจ้งข้อมูลผิดของบริษัท/ห้างหุ้นส่วน " +
                        this.company_name +
                        "โดย ผู้ใช้งาน Ebidding(" +
                        this.$session.get("username") +
                        ")",
                      channelSlack: "devnotify",
                      bearerLine: "tvQ4ioaIiXfiUvp1XfeucZE7VYGNyC6KKdpnSDGCoXX",
                    }
                  );
                  this.$bvModal
                    .msgBoxOk(
                      "ขอบคุณที่เเจ้งข้อมูลห้เราทราบ ทางเราจะดำเนินการตรวจสอบให้เร็วที่สุด",
                      {
                        title: "เรียบร้อย",
                        size: "sm",
                        buttonSize: "sm",
                        okVariant: "success",
                        headerClass: "p-2 border-bottom-0",
                        footerClass: "p-2 border-top-0",
                        centered: true,
                        okTitle: "ตกลง",
                      }
                    )
                    .then((value) => {
                      if (value) {
                        axios.post(
                          "https://www.kmppartners.info:1009/api/ebidding/access_log",
                          {
                            access_username: this.$session.get("username"),
                            access_module:
                              "เเจ้งข้อมูลประกาศ E-Bidding ไม่ถูกต้อง",
                            access_ipaddress: this.access_ipaddress,
                          }
                        );
                        this.$refs["modal-com"].hide();
                        this.$refs["modal-ebid-cust"].hide();
                      }
                    });
                } else {
                  this.$bvToast.toast(res.data.error, {
                    title: "ผิดพลาด",
                    autoHideDelay: 5000,
                    appendToast: true,
                    variant: "danger",
                  });
                }
              });
          }
        });
    },
    searchCom: function () {
      axios
        .post("https://www.kmppartners.info:1009/api/ebidding/customer/name", {
          name: this.select_company,
        })
        .then((res) => {
          if (res.data.status) {
            axios.post(
              "https://www.kmppartners.info:1009/api/ebidding/access_log",
              {
                access_username: this.$session.get("username"),
                access_module:
                  "ดูข้อมูลผู้ชนะ E-Bidding(" +
                  res.data.response.company_name +
                  ")",
                access_ipaddress: this.ipaddress,
              }
            );
            this.ebidding_request_edit_customer_tax = null;
            this.ebidding_request_edit_customer_tax =
              res.data.response.ebidding_customer_tax;
            this.customer_show.company_name = res.data.response.company_name;
            this.customer_show.address_customer =
              res.data.response.address_customer;
            this.customer_show.date_regist_customer =
              res.data.response.date_regist_customer;
            this.customer_show.regist_capital_customer =
              res.data.response.regist_capital_customer + " บาท";
            this.customer_show.ebidding_customer_tax =
              res.data.response.ebidding_customer_tax;
            this.customer_show.tel = res.data.response.tel;
            this.customer_show.email = res.data.response.email;
            if (
              res.data.response.ebidding_customer_tax.charAt(0) === "9" &&
              res.data.response.ebidding_customer_tax.charAt(1) === "9"
            ) {
              this.other = true;
            } else {
              this.other = false;
            }
            axios
              .post(
                "https://www.kmppartners.info:1009/api/ebiddomg/committee/name",
                {
                  name: this.select_company,
                }
              )
              .then((rest) => {
                if (rest.data.status) {
                  this.committee = "";
                  for (
                    let index = 0;
                    index < rest.data.response.length;
                    index++
                  ) {
                    if (index === rest.data.response.length - 1) {
                      this.committee +=
                        rest.data.response[index].committee_name;
                    } else {
                      this.committee +=
                        rest.data.response[index].committee_name + "\n";
                    }
                  }
                  this.$refs["modal-com"].show();
                } else {
                  this.$bvToast.toast(rest.data.error, {
                    title: "ผิดพลาด",
                    autoHideDelay: 5000,
                    appendToast: true,
                    variant: "danger",
                  });
                }
              });
          } else {
            this.$bvToast.toast(res.data.error, {
              title: "ผิดพลาด",
              autoHideDelay: 5000,
              appendToast: true,
              variant: "danger",
            });
          }
        });
    },
    search: function () {
      if (
        this.current_date_start === null &&
        this.current_date_end === null &&
        (this.province_name === null || this.province_name === "") &&
        (this.project_no === null || this.project_no === "") &&
        (this.company_name === null || this.company_name === "") &&
        this.job_type === null &&
        (this.employer === null || this.employer === "")
      ) {
        this.$bvModal.msgBoxOk("กรุณากรอกเงื่อนไขในการค้นหาข้อมูล", {
          title: "ลองใหม่อีกครั้ง",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          headerClass: "p-2 border-bottom-0",
          footerClass: "p-2 border-top-0",
          centered: true,
          okTitle: "ตกลง",
        });
      } else {
        if (this.$session.get("role") === "Customer") {
          this.$refs["content-ads"].show();
        }
        axios.post(
          "https://www.kmppartners.info:1009/api/ebidding/access_log",
          {
            access_username: this.$session.get("username"),
            access_module: "ค้นหาประกาศ E-Bidding",
            access_ipaddress: this.access_ipaddress,
          }
        );
        if (this.company_name === "") {
          this.company_name = null;
        }
        if (this.province_name === "") {
          this.province_name = null;
        }
        if (this.project_no === "") {
          this.project_no = null;
        }
        axios
          .post("https://www.kmppartners.info:1009/api/ebidding/all", {
            role: this.$session.get("role"),
            current_date_start: this.current_date_start,
            current_date_end: this.current_date_end,
            province_name: this.province_name,
            project_no: this.project_no,
            company_name: this.company_name,
            job_type: this.job_type,
            employer: this.employer,
          })
          .then((res) => {
            if (res.data.statusEbid) {
              this.rows = res.data.response;
              setTimeout(this.hideAdsSearch, 10000);
              this.$refs["table-data"].resetTable();
            }
          });
      }
    },
    addEbid: function () {
      this.$router.push("/Inputdata");
    },
    formatFn: function (value) {
      value = value.toLocaleString(undefined, { maximumFractionDigits: 2 });
      return value;
    },
    selectEbidding: function (params) {
      if (this.$session.get("role") === "Customer") {
        axios.post(
          "https://www.kmppartners.info:1009/api/ebidding/access_log",
          {
            access_username: this.$session.get("username"),
            access_module:
              "ดูข้อมูล Ebidding รหัสโครงการ " + params.row.project_no,
            access_ipaddress: this.$session.get("ipaddress"),
          }
        );
      }
      if (this.$session.get("role") === "Admin") {
        this.ctlLock = true;
        if (params.row.approved === "0") {
          this.approved = false;
        } else {
          this.approved = true;
        }
      } else {
        this.ctlLock = false;
      }
      this.data_selected.date_invite = null;
      axios
        .post("https://www.kmppartners.info:1009/api/ebidding/project_id", {
          project_id: params.row.id,
        })
        .then((res) => {
          if (res.data.statusEbid) {
            console.log(res.data.response);
            this.data_selected.id = params.row.id;
            if (this.$session.get("role") === "Customer") {
              this.ebidding_request_edit_projectno = null;
              this.ebidding_request_edit_projectno =
                res.data.response.project_no;
              this.data_selected.standard_price = res.data.response.standard_price
                .toFixed(2)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              this.data_selected.auction_price = res.data.response.auction_price
                .toFixed(2)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            } else {
              this.data_selected.standard_price =
                res.data.response.standard_price;
              this.data_selected.auction_price =
                res.data.response.auction_price;
            }
            this.data_selected.updateBy = this.$session.get("username");
            this.data_selected.old_project_no = res.data.response.project_no;
            this.data_selected.project_name = res.data.response.project_name;
            if (res.data.response.announce_date === null) {
              this.data_selected.announce_date = "00-00-0000";
            } else {
              this.data_selected.announce_date = res.data.response.announce_date.replace(
                /\//g,
                "-"
              );
            }
            if (
              res.data.response.announced_date === null ||
              res.data.response.announced_date === ""
            ) {
              this.data_selected.date_invite = "00-00-0000";
            } else {
              this.data_selected.date_invite = res.data.response.announced_date.replace(
                /\//g,
                "-"
              );
            }
            this.data_selected.job_type = res.data.response.ebidding_jobtype_id;
            this.data_selected.approved_by = res.data.response.approved_by;
            this.select_province = res.data.response.province_name;
            this.data_selected.project_no = res.data.response.project_no;
            this.select_company = res.data.response.ebidding_customer_name;
            this.data_selected.employor = res.data.response.employor;
            this.data_selected.discount = res.data.response.discount;
            this.data_selected.document = res.data.response.document;
          }
          if (
            this.$session.get("role") === "Customer" ||
            this.$session.get("role") === "Engineer"
          ) {
            this.$refs["modal-ebid-cust"].show();
          } else {
            this.$refs["modal-ebid"].show();
          }
        });
    },
    updateEbid: function (e) {
      e.preventDefault();
      this.data_selected.province_name = this.select_province;
      this.data_selected.company_name = this.select_company;
      let pattern = /^([0-9]{2})-([0-9]{2})-([0-9]{4})$/;
      if (
        this.data_selected.announce_date === "" ||
        this.data_selected.project_name === "" ||
        this.data_selected.province_name === "" ||
        this.data_selected.project_no === "" ||
        this.data_selected.standard_price === "" ||
        this.data_selected.company_name === "" ||
        this.data_selected.employor === "" ||
        this.data_selected.auction_price === ""
      ) {
        this.$bvToast.toast(
          "ไม่สามารถบันทึกข้อมูลได้ กรุณากรอกข้อมูลให้ครบทุกช่อง",
          {
            title: "ผิดพลาด",
            autoHideDelay: 3000,
            appendToast: true,
            variant: "danger",
          }
        );
      } else if (!pattern.test(this.data_selected.announce_date)) {
        this.$bvToast.toast("กรุณากรอกวันที่ให้ถูกต้อง (วว-ดด-ปปปป)", {
          title: "ผิดพลาด",
          autoHideDelay: 3000,
          appendToast: true,
          variant: "danger",
        });
        this.$refs["date-input"].focus();
      } else if (!pattern.test(this.data_selected.date_invite)) {
        this.$bvToast.toast("กรุณากรอกวันที่ให้ถูกต้อง (วว-ดด-ปปปป)", {
          title: "ผิดพลาด",
          autoHideDelay: 3000,
          appendToast: true,
          variant: "danger",
        });
        this.$refs["date-input-invit"].focus();
      } else {
        this.$bvModal
          .msgBoxConfirm("ต้องการเเก้ไขข้อมูลโครงการใช่หรือไม", {
            title: "ต้องการดำเนินการต่อไหม?",
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            cancelVariant: "danger",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true,
            okTitle: "ตกลง",
            cancelTitle: "ยกเลิก",
          })
          .then((value) => {
            if (value) {
              axios
                .post(
                  "https://www.kmppartners.info:1009/api/ebidding/project_id/update",
                  this.data_selected
                )
                .then((res) => {
                  if (res.data.statusUpdate) {
                    this.$bvModal
                      .msgBoxOk("บันทึกข้อมูลเรียบร้อยเเล้ว", {
                        title: "สำเร็จ",
                        size: "sm",
                        buttonSize: "sm",
                        okVariant: "success",
                        headerClass: "p-2 border-bottom-0",
                        footerClass: "p-2 border-top-0",
                        centered: true,
                        okTitle: "ตกลง",
                      })
                      .then((value) => {
                        if (value) {
                          axios
                            .post(
                              "https://www.kmppartners.info:1009/api/ebidding/access_log",
                              {
                                access_username: this.$session.get("username"),
                                access_module: "เเก้ไขประกาศ E-Bidding",
                                access_ipaddress: this.access_ipaddress,
                              }
                            )
                            .then((rest) => {
                              if (rest.data.statusLog) {
                                location.reload();
                              }
                            });
                        }
                      });
                  } else {
                    this.$bvModal
                      .msgBoxOk(res.data.error, {
                        title: "ผิดพลาด",
                        size: "sm",
                        buttonSize: "sm",
                        okVariant: "danger",
                        headerClass: "p-2 border-bottom-0",
                        footerClass: "p-2 border-top-0",
                        centered: true,
                        okTitle: "ตกลง",
                      })
                      .then((value) => {
                        if (value) {
                          location.reload();
                        }
                      });
                  }
                });
            }
          });
      }
    },
    closeEbid: function () {
      this.$refs["modal-ebid"].hide();
    },
    calDiscount: function () {},
  },
};
</script>

<style>
.content-text {
  font-size: 14px;
}
.box-list-ebid {
  min-height: 100%;
  width: 100%;
  position: absolute;
  background-color: rgb(231, 231, 231) !important;
}
.list-ebid {
  font-family: "K2D";
  margin: 2% !important;
  padding-bottom: 6%;
}
@media (max-width: 600px) {
  .list-ebid {
    padding-bottom: 50% !important;
  }
}
@media (max-width: 1024px) {
  .list-ebid {
    margin-bottom: 13% !important;
  }
}
.box-list-ebid .list-ebid .container {
  margin-left: 0px !important;
  margin-right: 0px !important;
  max-width: 100% !important;
}
.search {
  padding: 1%;
}
.table {
  padding: 1%;
}
.head-search {
  background-color: #005a7c;
  color: white;
  padding-top: 2%;
}
.content-search {
  background-color: white;
  color: black;
  padding-top: 3%;
  padding-bottom: 5%;
}
.input-group-text {
  padding: 0px !important;
  border: 0px !important;
  background-color: #fff !important;
}
.btnsearch {
  margin-left: 3px !important;
  background-color: #005a7c !important;
}
.btnsearch:hover {
  margin-left: 3px !important;
  background-color: rgb(27, 27, 27) !important;
}
.btnaddebid {
  margin-left: 3px !important;
  background-color: #005a7c !important;
}
.btnaddebid:hover {
  margin-left: 3px !important;
  background-color: rgb(27, 27, 27) !important;
}
.center {
  padding-top: 2%;
  padding-bottom: 3%;
  text-align: center !important;
}
.space {
  margin-bottom: 2%;
}
.label {
  color: red;
}
.modal-header {
  background-color: #005a7c !important;
  color: white !important;
}
.coms {
  height: 100% !important;
}
.img-ads {
  max-width: 100%;
  max-height: 100%;
  display: block;
}
.img-ads:hover {
  max-width: 100%;
  max-height: 100%;
  display: block;
}
.ads-block {
  padding: 0px !important;
}
</style>
